<template>
    <div>
        <!--<Section :title="标题">
            <div style="padding: 20px">车位锁</div>
        </Section>-->
        <Section title="车位锁管理">
            <FilterBox :item-right="10" inline style="padding: 20px 0px 10px 22px;">
                <FilterBoxItem>
                    <Input style="width: 200px" :maxlength="20" placeholder=' 搜索车位锁ID/车位号' v-model="searchText" />
                </FilterBoxItem>

                <!--<FilterBoxItem label="">
                    <Select style="width: 180px" v-model="floorSelect">
                        <Option v-for="item in floorNames" :value="item.value">
                            {{item.name}}
                        </Option>
                    </Select>
                </FilterBoxItem>-->

                <FilterBoxItem>
                    <Select style="width: 180px" v-model="searchForbidden">
                        <Option value="all">
                            是否禁用-全部
                        </Option>
                        <Option value="0">
                            是否禁用-否
                        </Option>
                        <Option value="1">
                            禁用
                        </Option>
                    </Select>
                </FilterBoxItem>

                <FilterBoxItem>
                    <Button type="primary" @click="search">
                        查找
                    </Button>
                </FilterBoxItem>

                <FilterBoxItem>
                    <!--<div>
                        <Icon type="ios-close-circle" size="18" color="#9ea7b4" @click="resetCond"/><span style="color: #9ea7b4">清空筛选</span>
                    </div>-->
                    <div @click="resetCond">
                        <Icon style="line-height: 47px" color="#999" size="15" type="ios-close-circle"  />
                        <span style="margin: 0px 6px;">清空筛选</span>
                    </div>
                </FilterBoxItem>

            </FilterBox>

            <LabelHeader >
                <div slot="before">
                    <span class="fs-12px colorA3 mr-10px">车位锁列表(共 <font color="#307deb">{{tabledata.length}}</font>条，已升锁<font color="#307deb">{{upLength}}</font>条，已降锁<font color="#307deb">{{downLength}}</font>个)</span>
                </div>
                <!--<div slot="after">
                    <Button type="primary" size="large" @click="addLock">+ 添加车位锁</Button>
                </div>-->
            </LabelHeader>

            <div style="padding: 20px">
                <Table border :columns="columns" :data="tabledata" :loading="isLoading" @on-selection-change="trChange"></Table>
            </div>

            <!--新增车位锁-->
            <!--<Modal v-model="addModal" id="addModal" class-name='vertical-center-modal' width="500">
                <div slot="header">
                    <b>新增车位锁</b>
                </div>
                <div class="pt-10px">
                    <Form :label-width="120" ref="formValidate" :model="formValidate" :rules="ruleValidate">
                        <FormItem prop="lockNumber">
                            <span slot='label' class="color-666 mr-10px">车位锁ID</span>
                            <Input style=" width: 200px;" :maxlength="10" v-model="formValidate.lockNumber" placeholder='输入locknumber，例 10000'></Input>
                            <span class="color-999 ml-10px"></span>
                        </FormItem>
                        <FormItem  prop="poiName">
                            <span slot='label' class="color-666 mr-10px">所属车位</span>
                            <AutoComplete v-model="formValidate.poiName" :transfer="false" :data="poiNames" @on-search="_poiNameChange" @on-select="_selectPoiName" placeholder="输入车位号" style="width:200px"></AutoComplete>
                        </FormItem>
                    </Form>
                </div>

                <div slot="footer">
                    <Button  type="primary" @click="addModal=false">取消</Button>
                    <Button  type="primary" @click="submit()">确认</Button>
                </div>
            </Modal>-->

            <!--删除确认框-->
            <!--<Modal v-model="delModal" id="delModal" class-name='vertical-center-modal' width="500">
                <div slot="header">
                    <b><Icon type="ios-alert" style="color:#ff6b23" /><span style="color: #ff6b23">删除确认</span></b>
                </div>
                <div class="pt-10px">
                    <div slot='label' class="color-666 mr-20px" style="text-align: center;padding: 20px">删除后，需重新绑定车位锁。</div>
                    <div slot='label' class="color-666 mr-10px" style="text-align: center;padding-bottom: 20px">是否继续 <label style="color: red">删除</label>？</div>
                </div>
                <div slot="footer">
                    <Button  type="default" @click="delModal=false">取消</Button>
                    <Button  type="error" @click="batchDeleteConfirm" >确认删除</Button>
                </div>
            </Modal>-->

            <!--升锁确认框-->
            <Modal v-model="upModal" id="upModal" class-name='vertical-center-modal' width="500">
                <div slot="header">
                    <b><Icon type="ios-alert" style="color:#ff6b23" /><span style="color: #ff6b23">升锁确认</span></b>
                </div>
                <div class="pt-10px">
                    <div slot='label' class="color-666 mr-20px" style="text-align: center;padding: 20px">如锁上有车辆，锁将自动回降。</div>
                    <div slot='label' class="color-666 mr-10px" style="text-align: center;padding-bottom: 20px">是否继续 <label style="color: red">升锁</label>？</div>
                </div>
                <!--<Spin fix v-if="isLoading">-->
                    <!--<Icon v-if="isLoading" type="ios-loading;" size=18 class="demo-spin-icon-load"></Icon>-->
                    <!--<div v-if="isLoading" style="color: #ff6b23">升锁中</div>-->
                <!--</Spin>-->
                <div slot="footer">
                    <Button  type="default" @click="upModal=false">取消</Button>
                    <Button  v-if="!isLoading" type="error" @click="lockOption('up')" >确认升锁</Button>
                    <Button  v-if="isLoading" type="error"  :loading="isLoading">升锁中</Button>
                </div>
            </Modal>

            <!--降锁确认框-->
            <Modal v-model="downModal" id="downModal" class-name='vertical-center-modal' width="500">
                <div slot="header">
                    <b><Icon type="ios-alert" style="color:#2196f3" /><span style="color: #2196f3">降锁确认</span></b>
                </div>
                <div class="pt-10px">
                    <div slot='label' class="color-666 mr-10px" style="text-align: center;padding: 20px">降锁后，如<label style="color: #01b0ff">3分钟</label>内无车停入将自动升锁。</div>
                    <div slot='label' class="color-666 mr-10px" style="text-align: center;padding-bottom: 20px">是否继续 <label style="color: #01b0ff">降锁</label>？</div>
                </div>
                <div slot="footer">
                    <Button  type="default" @click="downModal=false">取消</Button>
                    <Button  v-if="!isLoading" type="primary" @click="lockOption('down')" >确认降锁</Button>
                    <Button  v-if="isLoading" type="primary"  :loading="isLoading">降锁中</Button>
                </div>
            </Modal>

            <!--禁用确认框-->
            <Modal v-model="forbiddenModal" id="forbiddenModal" class-name='vertical-center-modal' width="500">
                <div slot="header">
                    <b><Icon type="ios-alert" style="color:#ff6b23" /><span style="color: #ff6b23">禁用确认</span></b>
                </div>
                <div class="pt-10px">
                    <div slot='label' class="color-666 mr-10px" style="text-align: center;padding: 20px">禁用后，任何会员在客户端均无法开关锁。</div>
                    <div slot='label' class="color-666 mr-10px" style="text-align: center;padding-bottom: 20px">是否继续 <label style="color: red">禁用</label>？</div>
                </div>
                <div slot="footer">
                    <Button  type="default" @click="forbiddenModal=false">取消</Button>
                    <Button  type="error" @click="forbid">确认禁用</Button>
                </div>
            </Modal>

            <!--恢复确认框-->
            <Modal v-model="validModal" id="validModal" class-name='vertical-center-modal' width="500">
                <div slot="header">
                    <b><Icon type="ios-alert" style="color:#3224ff" /><span style="color: #3224ff">恢复确认</span></b>
                </div>
                <div class="pt-10px">
                    <div slot='label' class="color-666 mr-10px" style="text-align: center;padding: 20px">恢复后，满足条件会员在客户端均可正常开关锁。</div>
                    <div slot='label' class="color-666 mr-10px" style="text-align: center;padding-bottom: 20px">是否继续  <label style="color: blue">恢复</label>？</div>
                </div>
                <div slot="footer">
                    <Button  type="default" @click="validModal=false">取消</Button>
                    <Button  type="primary" @click="release">确认恢复</Button>
                </div>
            </Modal>
        </Section>
    </div>
</template>

<script>

    import LabelHeader from '@/modules/LabelHeader'
    import FilterBox from '@/modules/FilterBox';
    import FilterBoxItem from '@/modules/FilterBoxItem';
    import Request from '../../../utils/request';
    import JQ from 'jquery';

    import { Table, Page, Button, Input, Select, Option, Modal , Form ,FormItem, AutoComplete,Icon, Spin} from 'iview';
    import IForm from "iview/src/components/form/form";
    import DATE from '../../../utils/util';

    var isFindByCondition = false;//是否为条件查询，条件查询时不能上下移动
    var isAbleToClickButton = true;//点击按钮是否有效，避免短时间重复点击
    export default {
        name: "TTable1",
        data () {
            return {
                columns: [
                    /*{
                        type: 'selection',
                        width: 60,
                        align: 'center'
                    },*/
                    {
                        title: '所属车位',
                        key: 'name',
                        align: 'center',
                        maxWidth: 160
                    },
                    {
                        title: '锁状态',
                        key: 'lockState',
                        align: 'center',
                        maxWidth: 160,
                        render: (h, params) => {
                            if(params.row.lockStatus === "01"){
                                return h('span', {style:{color:"#FF3300"}}, '已降锁')
                            }
                            if(params.row.lockStatus === "02"){
                                return h('span', {}, '已升锁')
                            }
                            if(params.row.lockStatus === "EF") {
                                return h('span', {style:{color: '#FF3300'}}, '非法未知')
                            }
                        }
                    },
                    {
                        title: '设备状态',
                        key: 'deviceStatus',
                        align: 'center',
                        maxWidth: 160,
                        render: (h, params) => {
                            if(params.row.deviceStatus === "01"){
                                return h('span', {}, '正常')
                            }
                            if(params.row.deviceStatus === "02"){
                                return h('span', {style:{color:"red"}}, '电量低')
                            }
                            if(params.row.deviceStatus === "03") {
                                return h('span', {style:{color: '#FF3300'}}, '担臂故障')
                            }
                            if(params.row.deviceStatus === "04") {
                                return h('span', {style:{color: '#FF3300'}}, '电机故障')
                            }
                            if(params.row.deviceStatus === "12") {
                                return h('span', {style:{color: '#FF3300'}}, '超声波传感器故障')
                            }
                        }
                    },
                    {
                        title: '车位状态',
                        key: 'placeStatus',
                        align: 'center',
                        maxWidth: 160,
                        render: (h, params) => {
                            if(params.row.placeStatus === "01"){
                                return h('span', {}, '空闲')
                            }
                            if(params.row.placeStatus === "02"){
                                return h('span', {style:{color: '#FF3300'}}, '占用')
                            }
                        }
                    },
                    {
                        title: '是否禁用',
                        align: 'center',
                        maxWidth: 120,
                        render: (h, params) => {
                            if(params.row.forbidden){
                                return h('span', {style:{color: '#FF3300'}}, '禁用');
                            }else{
                                return h('span', {}, '否');
                            }
                        }
                    },
                    {
                        title: '车位锁ID(lockNumber)',
                        key: 'lockNumber',
                        align: 'center',
                        minWidth: 160
                    },
                    {
                        title: '所属楼层',
                        key: 'floorName',
                        align: 'center',
                        maxWidth: 140
                    },
                    {
                        title: '状态更新时间',
                        key: 'updatedTime',
                        align: 'center',
                        width: 180,
                        render: (h, params) => {
                            if(params.row.updatedTime){
                                return h('span', {}, DATE.dateFormat(params.row.updatedTime,'yyyy-MM-dd hh:mm:ss'))
                            }
                        }
                    },
                    {
                        title: '操作',
                        align: 'center',
                        width: 180,
                        render: (h, params) => {

                            let that = this;
                            let btnStyle = "padding:0 10px;";

                            var buttons = [];

                            /*h('a', {style: btnStyle, on: {
                                    click: () => {
                                        this.$refs['formValidate'].resetFields();
                                        this.formValidate.lockNumber=params.row.lockNumber;
                                        this.formValidate.poiName=params.row.poiName;
                                        this.parkingLock = params.row;
                                        this.addModal = true;
                                    }
                                }}, '编辑')*/

                            if(params.row.lockStatus==="02"){
                                buttons.push(h('a', {style: btnStyle, on: {
                                        click: () => {
                                            this.LockNumber = params.row.lockNumber;
                                            this.isLoading = false;
                                            this.downModal = true;
                                        }
                                    }}, '降锁'))
                            }
                            if(params.row.lockStatus==="01"){
                                buttons.push(h('a', {style: btnStyle, on: {
                                        click: () => {
                                            this.LockNumber = params.row.lockNumber;
                                            this.isLoading = false;
                                            this.upModal = true;
                                        }
                                    }}, '升锁'))
                            }
                            if(!params.row.forbidden){
                                buttons.push(h('a', {style: btnStyle, on: {
                                        click: () => {
                                            // isForbidden 1 是 0 否
                                            this.LockNumber = params.row.lockNumber;
                                            this.isLoading = false;
                                            this.forbiddenModal = true;
                                        }
                                    }}, '禁用'))
                            }
                            if(params.row.forbidden){
                                buttons.push(h('a', {style: btnStyle, on: {
                                        click: () => {
                                            this.LockNumber = params.row.lockNumber;
                                            this.isLoading = false;
                                            this.validModal = true;
                                        }
                                    }}, '恢复'))
                            }

                            /*let _hideTop = params.index==0?" visibility: hidden;":" ";
                            let _hideBom =  params.index==(this.tabledata.length-1)?" visibility: hidden;":" ";
                            if(!isFindByCondition){
                                buttons.push(h('a', {style: btnStyle + _hideTop, on: {
                                        click: () => {
                                            var index = params.index;
                                            this.move(params.row,this.tabledata[index-1]);
                                        }
                                    }}, '上移'))
                                buttons.push(h('a', {style: btnStyle + _hideBom, on: {
                                        click: () => {
                                            var index = params.index;
                                            this.move(params.row,this.tabledata[index+1]);
                                        }
                                    }}, '下移'))
                                // buttons.push(h('a', {style: btnStyle + _hideTop}, '上移'))
                                // buttons.push(h('a', {style: btnStyle+ _hideBom}, '下移'))
                            }*/
                            return h('div',buttons);
                        }
                    }
                ],

                formValidate: {
                    lockNumber:'',
                    poiName:''
                },
                ruleValidate: {
                    lockNumber:[
                        {required:true, message:'请输入locknumber'}
                    ],
                    poiName: [
                        {required:true, message: '车位号不能为空', trigger: 'blur' }
                    ]
                },

                tabledata: [],  //列表展示数据
                resultdata:[],  //请求返回总数数据

                loading:false, //加载状态

                //检索条件
                searchForbidden:"all",
                searchText:"",//查询条件文本

                LockNumber:null, //选中车位锁

                floorNames:[],//楼层名称数组
                pois:[],//根据名称查询到的poi数组
                poiNames:[],//poi数组拼接的字符串
                isFindPoi:true,
                ID:null,//当前操作行的ID
                addModal:false,//添加车位锁编辑框
                delModal:false,//删除框
                upModal:false,//升锁编辑框
                downModal:false,
                forbiddenModal:false,
                validModal:false,
                parkingLock:null,//当前编辑的车位锁
                lockNumber:null,
                poiName:null,
                floorSelect:"-1",//v-modal 双向绑定后设置初始默认选中

                poiSelect:-1,
                upLength:0,//已升锁数据条数
                downLength:0,//已降锁数据条数
                selectedArr:[],//选中的数据
                isLoading:false,//加载动画
            }

        },
        methods: {

            //查询所有记录
            request() {
                this.isLoading = true;
                this.$request.get(`${this.$HOST}/back/parkingLock`).then((res)=>{
                    this.isLoading = false;
                    if (!res.data.code && res.data.result) {
                        console.log(res.data.result);
                        this.tabledata = res.data.result;
                        this.resultdata = res.data.result;
                        this.tabledata.filter((item)=>{
                            if(item.lockStatus === "02"){
                                this.upLength+=1;
                            }
                            if(item.lockStatus === "01"){
                                this.downLength+=1;
                            }
                        });
                    }
                    isAbleToClickButton = true;
                });
            },

            /**
             * 检索事件
             */
            search (){
                this.loading = true;
                let array = [];
                if (this.searchText.trim().length){
                    array = this.resultdata.filter((item)=>{
                        return item.lockNumber.indexOf(this.searchText)!==-1 || item.name.indexOf(this.searchText)!==-1;
                    })
                }else array = this.resultdata;
                if (this.searchForbidden!=="all")
                {
                    array = array.filter((item)=>{
                        return parseInt(item.forbidden)===parseInt(this.searchForbidden);
                    });
                }
                this.tabledata = array;
                this.loading = false;
            },

            //获取楼层数量
            _floorNames() {

                let that = this;
                JQ.get(this.$MAP_URL,{buildingID:this.$BUILDING_ID,token:that.$Build.token},function (res) {
                    that.floorNames.push({value:'-1',name:"所属楼层-全部"})
                    if (res.success && res.count > 0) {
                        res.MapInfo.forEach(function (item) {
                            // that.floorNames.push({value: item.mapID, name: item.floorName})
                            that.floorNames.push({value: item.floorName, name: item.floorName})
                        })
                    }
                });
            },

            // 输入框改变事件
            _textChange(text) {

                this.findByCond();
            },


            //清空筛选
            resetCond(){
                this.searchText = "";
                this.floorSelect = "-1";//v-modal 双向绑定后设置初始默认选中
                this.searchForbidden = "all";
                this.request();
            },

            //添加车位锁
            addLock() {
                this.$refs['formValidate'].resetFields();
                this.parkingLock = null;
                this.pois = [];
                this.poiNames = [];
                this.addModal = true;
            },


            //checkbox改变
            trChange:function(row){

                this.selectedArr = row;
            },

            //批量删除车位锁
            batchDelete(){

                if(this.selectedArr.length<1){
                    this.$Message.error("未勾选删除数据！");
                    return;
                }
                this.delModal = true;
            },



            hideModal (){
                this.upModal = false;
                this.downModal = false;
                this.forbiddenModal = false;
                this.validModal = false;
            },


            /**
             * 禁用
             */
            forbid (){
                if (this.isLoading) return;
                this.isLoading = true;
                this.$request.post("/back/parkingLock/forbid?lockNumber="+this.LockNumber,null,{baseURL:this.$HOST}).then((res)=>{
                    this.isLoading = false;
                    if (!res.data.code && res.data.result){
                        this.hideModal();
                        this.$Message.success("已成功禁用！")
                    }else this.$Message.error(res.data.message);
                    this.request();
                });
            },


            /**
             * 恢复
             */
            release (){
                if (this.isLoading) return;
                this.isLoading = true;
                this.$request.post("/back/parkingLock/release?lockNumber="+this.LockNumber,null,{baseURL:this.$HOST}).then((res)=>{
                    this.isLoading = false;
                    if (!res.data.code && res.data.result){
                        this.hideModal();
                        this.$Message.success("已恢复！")
                    }else this.$Message.error(res.data.message);
                    this.request();
                });
            },


            //升降锁操作
            lockOption:function (option) {

                if (this.isLoading) return;
                this.isLoading = true;
                this.$request.post("/back/parkingLock/"+option+"?lockNumber="+this.LockNumber,null,{baseURL:this.$HOST}).then((res)=>{
                    this.isLoading = false;
                    if (!res.data.code && res.data.result){
                        this.hideModal();
                        this.$Message.success("操作成功！")
                    }else this.$Message.error(res.data.message);
                    this.request();
                });
            },


            //上移下移
            move:function(row,row1){
            }
        },

        created(){
            this.request();
            this._floorNames();
        },

        mounted () {


        },

        components: {
            IForm,
            LabelHeader,
            FilterBox,
            FilterBoxItem,
            Table,
            Button,
            Page,
            Input,
            Select,
            Option,
            Modal,
            Form,
            FormItem,
            AutoComplete,
            Icon,
            Spin
        }
    }
</script>

<style scoped>
</style>
